module.exports = __webpack_public_path__ + "img/arrow-right-mint.53f19eed.svg";